module.exports = __webpack_public_path__ + "img/incendio.56020a25.svg";